import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

interface User {
  id: string
  email: string
  name: string
  avatar_url?: string
}

async function fetchMe(): Promise<User | null> {
  const res = await fetch('/api/auth/me', { credentials: 'include' })
  if (res.status === 401) return null
  if (!res.ok) return null
  return res.json()
}

export function useAuth() {
  const qc = useQueryClient()
  const { data: user, isLoading } = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: fetchMe,
    retry: false,
    staleTime: 5 * 60 * 1000,
  })

  const logoutMutation = useMutation({
    mutationFn: () => fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }),
    onSuccess: () => qc.setQueryData(['auth', 'me'], null),
  })

  return {
    user: user ?? null,
    isLoading,
    isAuthenticated: !!user,
    login: () => { window.location.href = '/api/auth/google' },
    logout: () => logoutMutation.mutate(),
  }
}
